import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Produtos from "@/pages/Produtos";
import Marcas from "@/pages/Marcas";
import QuemSomos from "@/pages/QuemSomos";
import Contactos from "@/pages/Contactos";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App min-h-screen bg-white text-[#222]">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="pt-[88px] md:pt-[96px]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produtos" element={<Produtos />} />
            <Route path="/marcas" element={<Marcas />} />
            <Route path="/quem-somos" element={<QuemSomos />} />
            <Route path="/contactos" element={<Contactos />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
